import { Reveal, GhostButton } from "@/components/common";
import { useI18n } from "@/i18n";
import { Wallet, Home, LayoutDashboard, Building2, Film, Download, ArrowRight } from "lucide-react";
import { useFormModal } from "@/lib/formContext";

const ICONS = { wallet: Wallet, home: Home, dashboard: LayoutDashboard, team: Building2, film: Film, download: Download };

export function ExtraInfo() {
  const { openForm } = useFormModal();
  const { t } = useI18n();
  const creditInfo = t("pricing.creditInfo");
  return (
    <Reveal className="mx-auto mt-16 max-w-6xl" data-testid="extra-info">
      <div className="rounded-3xl border border-re-line bg-re-soft/50 p-8 md:p-12">
        <h3 className="px-2 pb-1 text-center font-heading text-2xl font-black leading-[1.15] tracking-tight text-re-ink md:text-3xl">
          {t("pricing.extraTitle")}
        </h3>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {creditInfo.map((info, i) => {
            const Icon = ICONS[info.icon];
            return (
              <div key={i} className="flex gap-4 rounded-2xl border border-re-line bg-white p-6">
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-xl bg-gradient-red">
                  <Icon className="h-5 w-5 text-white" />
                </span>
                <div>
                  <h4 className="font-heading text-lg font-bold text-re-ink">{info.title}</h4>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-re-muted">{info.text}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex justify-center">
          <GhostButton testid="custom-solution-cta" onClick={() => openForm("maat")}>
            {t("pricing.customCta")} <ArrowRight className="h-4 w-4" />
          </GhostButton>
        </div>
      </div>
    </Reveal>
  );
}
